import type { SVGProps } from 'react';
const SvgExternalIndicator = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" height={24} viewBox="0 0 24 24" width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect height={22} rx={11} stroke="#fff" strokeOpacity={0.6} strokeWidth={2} width={22} x={1} y={1} />
    <g clipPath="url(#external-indicator_svg__a)">
      <path
        d="M17.25 10.25v-3.5m0 0h-3.5m3.5 0L12 12m-1.167-5.25H9.55c-.98 0-1.47 0-1.844.19a1.75 1.75 0 0 0-.765.766c-.191.374-.191.864-.191 1.844v4.9c0 .98 0 1.47.19 1.845.169.329.436.596.766.764.374.191.864.191 1.844.191h4.9c.98 0 1.47 0 1.845-.19a1.75 1.75 0 0 0 .764-.765c.191-.375.191-.865.191-1.845v-1.283"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </g>
    <defs>
      <clipPath id="external-indicator_svg__a">
        <path d="M5 5h14v14H5z" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgExternalIndicator;
export { SvgExternalIndicator };
